import React, { useEffect } from 'react'
import { Button, DatePicker, Form, Input, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { FormButton } from './indicator.styled'
import dayjs from 'dayjs'

function IndicatorDownload (props) {
  const { modalData, defConfig, defPlaceholder, handleModalClose, loading, form } = props
  const { t: ln_t } = useTranslation()
  const { data, disableDate, setting } = modalData || {}

  useEffect(() => {
    if (!modalData?.open) return
    const timeInterval = setting?.startDate && setting?.endDate ? [dayjs(setting?.startDate), dayjs(setting?.endDate)] : undefined
    const order = setting?.sort?.includes('-') ? 'DESC' : 'ASC'
    form.setFieldsValue({ name: data?.name || ln_t('indicator.allIndicators'), timeInterval, order })
  }, [modalData])

  return <>
    <Form.Item {...defConfig('name', 'input')}>
      <Input placeholder={defPlaceholder('name', 'input')} disabled />
    </Form.Item>
    <Form.Item {...defConfig('timeInterval', 'select', false)}>
      <DatePicker.RangePicker style={{ width: '100%' }} disabled={disableDate} />
    </Form.Item>
    <Form.Item {...defConfig('order', 'select', false)} >
      <Select
        showSearch
        placeholder={defPlaceholder('order', 'select')}
        optionFilterProp="children"
        options={[{ value: 'ASC', label: ln_t('dashboard.asc') }, { value: 'DESC', label: ln_t('dashboard.desc') }]}
      />
    </Form.Item>
    <Form.Item {...defConfig('downloadFormat', 'select')} >
      <Select
        showSearch
        placeholder={defPlaceholder('downloadFormat', 'select')}
        optionFilterProp="children"
        options={[{ value: 'xlsx', label: 'xlsx' }, { value: 'json', label: 'json' }]}
      />
    </Form.Item>

    <FormButton>
      <Button type="default" onClick={handleModalClose}>{ln_t('util.cancel')}</Button>
      <Button type="primary" htmlType="submit" loading={loading}>{ln_t('util.download')}</Button>
    </FormButton>
  </>
}

export default IndicatorDownload
